import { UserRole } from 'shared/types/userRole';
import { isStandard } from '../../role/isStandard';
import { isViewer } from '../../role/isViewer';
import { isAtLeastManager } from './isAtLeastManager';

// defines if user has access to the project (can have also visible_without_access role)

export function isAtLeastStandard(role: UserRole): boolean {
  return isStandard(role) || isViewer(role) || isAtLeastManager(role);
}
